module.exports = __webpack_public_path__ + "img/ji6a.56318cec.png";